<template>
  <div class="cooperationPage" :class="[_isMobile() ? 'mobilePage' : '']">
    <p class="cooperationTitle">合作单位</p>
    <div class="cooperationBox">
        <p class="cooperationBoxTitle">学术指导单位</p>
        <a-row type="flex" :gutter="!_isMobile()?[24,24]:[12,12]" style="width: 100%;">
            <a-col :xs="12" :sm="12" :md="6" v-for="item,index in comLogo.com1" :key="index">
                <div class="cooperationList"><img :src="item" alt=""></div>
            </a-col>
        </a-row>
    </div>
    <div class="cooperationBox">
        <p class="cooperationBoxTitle">学校、科普单位</p>
        <a-row type="flex" :gutter="!_isMobile()?[24,24]:[12,12]" style="width: 100%;">
            <a-col :xs="12" :sm="12" :md="6" v-for="item,index in comLogo.com2" :key="index">
                <div class="cooperationList"><img :src="item" alt=""></div>
            </a-col>
        </a-row>
    </div>
    <div class="cooperationBox">
        <p class="cooperationBoxTitle">企业</p>
        <a-row type="flex" :gutter="!_isMobile()?[24,24]:[12,12]" style="width: 100%;">
            <a-col :xs="12" :sm="12" :md="6" v-for="item,index in comLogo.com3" :key="index">
                <div class="cooperationList"><img :src="item" alt=""></div>
            </a-col>
        </a-row>
    </div>
  </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
export default {
  name: '',
  mixins:[mixinDevice],
  components: {},
  data() {
    return {
        comLogo:{}
    }
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    if (this.tenantConfig.comLogo1) {
      this.comLogo.com1 = this.tenantConfig.comLogo1.split(",");
    }
    if (this.tenantConfig.comLogo2) {
      this.comLogo.com2 = this.tenantConfig.comLogo2.split(",");
    }
    if (this.tenantConfig.comLogo3) {
      this.comLogo.com3 = this.tenantConfig.comLogo3.split(",");
    }
  },
  mounted() {},
  methods: {}
}
</script>
<style lang='scss' scoped>
.cooperationPage{
    padding: 40px;
    background-image: url('../assets/aice2/HZQY_BACKGROUND.png');
    background: 100% auto;
    .cooperationTitle{
        font-weight: 600;
        font-size: 32px;
        color: #FFFFFF;
        line-height: 46px;
        text-align: center;
    }
    .cooperationBox{
        margin-bottom: 40px;
        .cooperationBoxTitle{
            font-weight: 600;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 23px;
            text-align: center;
        }
        .cooperationList{
            width: 100%;
            height: 96px;
            border-radius: 12px;
            overflow: hidden;
            border: 1px solid #ccc;
            background: #ffffff36;
            img{
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
    }
}
.mobilePage{
    padding: 12px !important;
    .cooperationBox{
        margin-bottom: 16px !important;
    }
    .cooperationBoxTitle{
        font-size: 14px !important;
        color: #323335 !important;
    }
    .cooperationList{
        height: 50px !important;
    }
}
</style>
